module.exports = __webpack_public_path__ + "components/panel/check-yeti/static/check-yeti--sp@2-3acecea5d5d237e95fe46ac7263e7173.jpg";